export const removeAllWhiteSpaces = (character: string) => character.replace(/ /g, '');